import EmtithalOfficeTasks from './emtithalOfficeTasksContainer';

export default EmtithalOfficeTasks;
